import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import { Box, Button, TextField } from "@mui/material";

// Основная обертка для страницы входа
export const SignInWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background: #e3ecfb;
`;

// Контейнер для основного содержимого
export const LoginContainer = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 20px;
  max-width: 100%;
`;

// Левая сторона с логотипом
export const LogoSide = styled(Box)`
  flex: 3;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 720px;
  position: relative;
  border-radius: 32px;
  background: radial-gradient(
    199.79% 199.79% at 50% -29.17%,
    var(--Color-Light-Light-blue-lightBlue_800, #236bcf) 0%,
    var(--Color-Light-Light-blue-lightBlue_700, #3573e3) 21.71%,
    #d5e3f6 57.18%,
    rgba(255, 255, 255, 0.37) 65.26%
  );
`;

// Правая сторона с формой
export const FormSide = styled(Box)`
  flex: 2;
  background: white;
  border-radius: 32px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  max-height: 720px;
`;

// Контейнер для логотипа 3D
export const Logo3DImage = styled("img")`
  width: 50%;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;

// Контейнер для ссылок в левой части
export const LeftSideLinksContainer = styled(Box)`
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  z-index: 2;
  padding: 0 40px;
`;

// Ссылка в левой части
export const LeftSideLink = styled("a")`
  color: #1a509b;
  text-decoration: none;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

// Форма входа
export const LoginForm = styled("form")`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

// Название бренда
export const BrandName = styled(Box)`
  color: #0d4da1;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

// Заголовок страницы
export const PageTitle = styled(Box)`
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 32px;
  color: #000;
`;

// Метка для поля формы
export const FormLabel = styled(Box)`
  font-size: 14px;
  margin-bottom: 8px;
  color: #000;
`;

// Стилизованное текстовое поле
export const StyledTextField = styled(TextField)`
  margin-bottom: 24px;
  width: 100%;
  & .MuiOutlinedInput-root {
    border-radius: 24px;
    background-color: white;
    outline: 1px solid #f0f0f0;
    outline-offset: -1px;
  }
  & .MuiOutlinedInput-input {
    padding: 16px 24px;
    font-size: 16px;
    font-family: Manrope;
    font-weight: 400;
    letter-spacing: 0.16px;
    color: #0d0a2c;
  }
  & .MuiInputLabel-root {
    font-size: 14px;
  }
  & .MuiFormHelperText-root.Mui-error {
    margin-left: 0;
    margin-top: 4px;
  }
`;

// Контейнер для чекбокса "Запомнить меня" и ссылки "Забыли пароль"
export const RememberForgotContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  padding-top: 4px;
  padding-bottom: 4px;
  gap: 52px;
`;

// Кнопка входа
export const LoginButton = styled(Button)`
  width: 100%;
  padding: 16px 24px;
  border-radius: 32px;
  background-color: #1a509b;
  color: white;
  text-transform: none;
  font-weight: 400;
  font-size: 16px;
  font-family: Manrope;
  letter-spacing: 0.16px;
  margin-top: 16px;
  margin-bottom: 12px;
  &:hover {
    background-color: #0d4da1;
  }
`;

// Контейнер для ссылки регистрации
export const SignupContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// Ссылка для регистрации
export const SignupLink = styled(Link)`
  width: 100%;
  padding: 8px 16px;
  border-radius: 32px;
  background-color: white;
  outline: 1px solid #f0f0f0;
  outline-offset: -1px;
  color: #0d0a2c;
  text-decoration: none;
  font-weight: 400;
  font-size: 14px;
  font-family: Manrope;
  letter-spacing: 0.06px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  &:hover {
    background-color: #f8f9fa;
  }
`;

// Ссылка "Забыли пароль"
export const ForgotPasswordLink = styled(Link)`
  color: #236bcf;
  text-decoration: none;
  font-weight: 700;
  font-size: 14px;
  font-family: Manrope;
  letter-spacing: 0.06px;
  padding: 8px 12px;
  border-radius: 32px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
